import { DISCOVERY_LAB_DISTRICTS } from '../DiscoveryLabConfig.js';
import {
  EvidenceLabScene,
  type EvidenceLabRouteDefinition,
} from '../minigames/evidence-lab/EvidenceLabScene.js';
import {
  SOUND_VIBRATION_ASSETS,
  SOUND_VIBRATION_ASSET_LIST,
  canEnterSoundVibrationDeck,
  getMissingSoundVibrationAssets,
} from './SoundVibrationAssets.js';
import { SOUND_VIBRATION_INVESTIGATION } from './SoundVibrationConfig.js';
import { canEnterEarthMaterialsYard } from '../earth-materials-yard/EarthMaterialsAssets.js';

export const SOUND_VIBRATION_SCENE_KEY = 'SoundVibrationDeck';

const ROUTE: EvidenceLabRouteDefinition = {
  sceneKey: SOUND_VIBRATION_SCENE_KEY,
  sceneTitle: 'SOUND & VIBRATION DECK',
  district: DISCOVERY_LAB_DISTRICTS.soundVibrationDeck,
  previousScene: 'LifeCyclePond',
  previousLabel: 'LIFE CYCLE POND',
  nextDistrict: DISCOVERY_LAB_DISTRICTS.earthMaterialsYard,
  nextScene: 'EarthMaterialsYard',
  nextLabel: 'EARTH MATERIALS YARD',
  nextUnavailableMessage:
    'The geology path is unlocked. Earth Materials Yard is awaiting its runtime QA gate.',
  config: SOUND_VIBRATION_INVESTIGATION,
  assets: {
    dormant: SOUND_VIBRATION_ASSETS.dormant,
    restored: SOUND_VIBRATION_ASSETS.restored,
    card: SOUND_VIBRATION_ASSETS.card,
  },
  assetList: SOUND_VIBRATION_ASSET_LIST,
  getMissing: getMissingSoundVibrationAssets,
  canEnter: canEnterSoundVibrationDeck,
  canEnterNext: canEnterEarthMaterialsYard,
};

export class SoundVibrationScene extends EvidenceLabScene {
  static readonly requiredImageKeys = SOUND_VIBRATION_ASSET_LIST.map(asset => asset.key);

  constructor() {
    super(ROUTE);
  }
}
